import * as z from 'zod';

import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { statusQuerySchema } from '@/_schemas/status-input';

export const salaryGradeQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
});
export type SalaryGradeQueryLinkerSchema = z.infer<typeof salaryGradeQueryLinkerSchema>;

export const salaryGradeQuerySchema = z.object({
  ...salaryGradeQueryLinkerSchema.shape,
  status: statusQuerySchema,
});

export type SalaryGradeQuerySchema = z.infer<typeof salaryGradeQuerySchema>;

export const salaryGradeQueryAllSchema = paginatedResponseSchema(salaryGradeQuerySchema);
export type SalaryGradeQueryAllSchema = z.infer<typeof salaryGradeQueryAllSchema>;
